import { CommunityLogo } from '@community_dev/pixels'
import React, { type JSX } from 'react'
import styled from 'styled-components'

const StyledSimpleLayout = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme?.COLORS?.APP_BACKGROUND_LEVEL_2};
`

const StyledMain = styled.div`
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

const StyledHeader = styled.div`
  width: 100%;
  background: ${({ theme }) => theme?.COLORS?.APP_BACKGROUND_LEVEL_3};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  padding: 12px 14px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
  @media (min-width: 720px) {
    padding: 18px 36px;
  }
`

const StyledLogo = styled.div`
  display: flex;
  color: ${({ theme }) => theme?.COLORS?.BUTTON_PRIMARY};
  opacity: 0.9;
`

const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

type SimpleLayoutProps = {
  children?: React.ReactNode
  className?: string
}

export function SimpleLayout({ children, className }: SimpleLayoutProps): JSX.Element {
  return (
    <StyledSimpleLayout className={className}>
      <StyledMain>
        <StyledHeader>
          <StyledLogo>
            <CommunityLogo height="24px" />
          </StyledLogo>
        </StyledHeader>
        <StyledContent>{children}</StyledContent>
      </StyledMain>
    </StyledSimpleLayout>
  )
}
